import styled from 'styled-components';

// const PURPLE = '#9D4DFF';

// export const Wrapper = styled.section`
//   padding:10px 16px ;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   gap: 32px;
//   position: relative;

//   @media (min-width: 768px){
//     padding: 32px 64px;
//   }

//   @media (min-width: 1200px){
//     gap:64px;
//     padding: 48px 120px;
//   }

//   @media (min-width: 1440px) {
//     padding: 48px 120px;
//   }
// `;


// export const Form = styled.form`
//   display: grid;
//   gap: 12px;
//   width: 100%;
//   max-width: 800px;
// `;

// export const Field = styled.div`
//   display: grid;
//   gap: 6px;
//   text-align: left;

//   label{
//     font-weight: 400;
//     font-style: Regular;
//     font-size: 12px;
//     line-height: 16px;
//     letter-spacing: 0px;
//   }
// `;

// const baseInput = `
//   angle: 0 deg;
//   opacity: 1;
//   border-radius: 8px;
//   border-width: 0.5px;
//   padding: 10px;
//   gap: 10px;
//   background-color: var(--color-1B1B1F, #1B1B1F);
//   border: 0.5px solid var(--color-666666, #666666);

//   &:focus{
//     border-color: ${PURPLE};
//     box-shadow: 0 0 0 3px rgba(157,77,255,.15);
//   }
// `;

// export const Input = styled.input`
//   ${baseInput}
// `;
// export const Textarea = styled.textarea`
//   ${baseInput} 
//   resize: none;
// `;

// export const ActionBtn = styled.button`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   width: 100%;
//   min-height: 40px;
//   margin: 0 auto;
//   border-radius: 8px;
//   border-width: 1px;
//   padding: 8px 16px;
//   gap: 8px;
//   opacity: 1;
//   font-weight: 600;
//   font-style: bold;
//   font-size: 16px;
//   line-height: 24px;
//   letter-spacing: 0px;
//   text-align: center;
//   background-image: linear-gradient(var(--color-A62AFF), var(--color-A62AFF)),
//   linear-gradient(120deg, var(--color-6A9DFF), var(--color-0057FF));
//   background-origin: border-box;
//   background-clip: padding-box, border-box;
//   border: 1px solid transparent;

//   @media (min-width: 850px){
//     height: 64px;
//   }

//   &:hover{
//      background-image: linear-gradient(var(--color-3F145E), var(--color-3F145E)),
//   linear-gradient(120deg, var(--color-6A9DFF), var(--color-0057FF));
//     } 
// `

// export const FileRow = styled.div`
//   display: grid;
//   grid-template-columns: minmax(0, 1fr) auto;
//   gap: 16px;

//   @media (min-width:500px){
//     grid-template-columns: 1fr 1fr;
//     align-items: center;
//   }
// `;

// export const FileName = styled.input`
//   ${baseInput}
// `;

// export const FileButtonBox = styled.label`
//   border-radius: 8px;
//   padding: 1px;
//  background-image:
//    linear-gradient(#0000, #0000),
//    linear-gradient(120deg, #D4E3FF, #004CDE);
//  background-origin: border-box;
//  background-clip: padding-box, border-box;

//  color: #fff;
//   &:hover {
//    box-shadow: 0 0 0 3px rgba(157,77,255,.15);
//   }
// `;


// export const FileButton = styled.label`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   padding: 10px 16px;
//   border-radius: 8px;
//   cursor: pointer;
//   user-select: none;
//   font-weight: 600;
//   font-style: Semibold;
//   font-size: 16px;
//   line-height: 24px;
//   letter-spacing: 0px;
//   text-align: center;
//   background-color: #000;

//   &:hover {
//     box-shadow: 0 0 0 3px rgba(157,77,255,.15);
//   }
// `;

export const Wrapper = styled.section`
  padding:10px 16px ;
  gap: 32px;
  position: relative;
  max-width: 1200px;
  margin: 0 auto;

  @media (min-width: 768px){
    padding: 32px 64px;
  }

  @media (min-width: 1440px) {
    padding: 48px 120px;
  }

  h2{
    font-weight: 700;
    font-style: Bold;
    font-size: 40px;
    line-height: 48px;
    letter-spacing: 2px;
    max-width: 842px;
    margin: 0 auto;
    margin-bottom: 32px;

    @media (min-width: 850px){
      font-size: 48px;
      line-height: 56px;
      letter-spacing: 2px;
    }
  }

  p{
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 1px;
    text-align: center;
    max-width: 842px;
    margin: 0 auto;
  }
`;


export const Email = styled.div`
  font-weight: 600;
  font-style: Semibold;
  font-size: 16px;
  line-height: 40px;
  letter-spacing: 1px;
  max-width: fit-content;
  margin: 0 auto;
  margin-top: 64px;

  border-radius: 8px;
  padding:16px 32px;
  border: 1px solid var(--color-ffffff);

  @media (min-width: 850px){
      font-size: 24px;
  }
`